import React from  'react';

import './Warning.css';

const Warning = ({visible, handler}) => {

    let display = (visible)?{display:'inherit'}:{display:'none'};

    return(
        <div className = "warning column centerItens centerContent" style={display}>
            <div className = 'content column nowrap centerItens'>
                <span className = 'message colorEIC'>
                    Por favor, digite apenas seu nome ou apelido.
                </span>
                <button onClick = {handler}>Entendi!</button>
            </div>
        </div>
    );
};

export default Warning;